import React, { useState, useEffect } from "react";
import ProductComponents from "./ProductComponents";
import axios from "axios";
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";

function ProductTable() {
  const [selectedBrand, setSelectedBrand] = useState("1");
  const [selectedProductType, setSelectedProductType] = useState("Finished");
  const [brands, setBrands] = useState([]);
  
  // Brand-wise and Product Type-wise headers
  const getHeadersForBrandAndProductType = (brandId, productType) => {
    const brandName = brands.find(b => b.id == brandId)?.brandname || "Manufacturing";
    
    // Common headers for all
    const commonHeaders = [
      { label: "Id", field: "id" },
      { label: "Product Description", field: "description" },
      { label: "Product Type", field: "producttype" },
      { label: "Brand", field: "brandname" },
      { label: "HSN Code", field: "hsnsacno" },
      { label: "Unit", field: "unitofmeasurement" },
      { label: "Action", field: "action" }
    ];

    // Manufacturing Brand Headers
    if (brandName === "Manufacturing") {
      if (productType === "Finished") {
        return [
          { label: "Id", field: "id" },
          { label: "Product Description", field: "description" },
          { label: "Customer Name", field: "companyname" },
          { label: "Model Number", field: "modelnumber" },
          { label: "Tag Number", field: "tagnumber" },
          { label: "Item Code", field: "itemcode" },
          { label: "HSN Code", field: "hsnsacno" },
          { label: "Serial Number", field: "serialnumber" },
          { label: "MOC", field: "moc" },
          { label: "Part No", field: "partno" },
          { label: "Labour Charges", field: "labourcharges" },
          { label: "Unit", field: "unitofmeasurement" },
          { label: "Action", field: "action" }
        ];
      }
      else if (productType === "Raw Material") {
        return [
          { label: "Id", field: "id" },
          { label: "Product Description", field: "description" },
          { label: "MOC", field: "moc" },
          { label: "Part No", field: "partno" },
          { label: "Size", field: "size" },
          { label: "HSN Code", field: "hsnsacno" },
          { label: "Schedule", field: "schedule" },
          { label: "Class", field: "classes" },
          { label: "Unit", field: "unitofmeasurement" },
          { label: "Action", field: "action" }
        ];
      }
      else if (productType === "Semi Finished") {
        return [
          { label: "Id", field: "id" },
          { label: "Product Description", field: "description" },
          { label: "Item Code", field: "itemcode" },
          { label: "MOC", field: "moc" },
          { label: "Part No", field: "partno" },
          { label: "Size", field: "size" },
          { label: "HSN Code", field: "hsnsacno" },
          { label: "Schedule", field: "schedule" },
          { label: "Class", field: "classes" },
          { label: "Rating", field: "rating" },
          { label: "Type", field: "type" },
          { label: "Unit", field: "unitofmeasurement" },
          { label: "Action", field: "action" }
        ];
      }
    }
    
    // Arai Spares Brand Headers
    else if (brandName === "Arai Spares") {
      if (productType === "Finished") {
        return [
          { label: "Id", field: "id" },
          { label: "Product Description", field: "description" },
          { label: "Customer Name", field: "companyname" },
          { label: "Model Number", field: "modelnumber" },
          { label: "Tag Number", field: "tagnumber" },
          { label: "Item Code", field: "itemcode" },
          { label: "HSN Code", field: "hsnsacno" },
          { label: "Serial Number", field: "serialnumber" },
          { label: "MOC", field: "moc" },
          { label: "Part No", field: "partno" },
          { label: "Unit", field: "unitofmeasurement" },
          { label: "Action", field: "action" }
        ];
      }
      else if (productType === "Services") {
        return [
          { label: "Id", field: "id" },
          { label: "Product Description", field: "description" },
          { label: "Customer Name", field: "companyname" },
          { label: "Model Number", field: "modelnumber" },
          { label: "Tag Number", field: "tagnumber" },
          { label: "Item Code", field: "itemcode" },
          { label: "HSN Code", field: "hsnsacno" },
          { label: "Serial Number", field: "serialnumber" },
          { label: "MOC", field: "moc" },
          { label: "Part No", field: "partno" },
          { label: "Unit", field: "unitofmeasurement" },
          { label: "Action", field: "action" }
        ];
      }
    }

    // Default fallback
    return commonHeaders;
  };

  const [headers, setHeaders] = useState(getHeadersForBrandAndProductType("1", "Finished"));

  // Update headers when brand or product type changes
  useEffect(() => {
    setHeaders(getHeadersForBrandAndProductType(selectedBrand, selectedProductType));
  }, [selectedBrand, selectedProductType, brands]);

  const productTypes = [
    { value: "Finished", label: "Finished" },
    { value: "Raw Material", label: "Raw Material" },
    { value: "Semi Finished", label: "Semi Finished" },
    { value: "Services", label: "Services" }
  ];

  // Fetch brands on component mount
  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}brand/findAllBrand`,
          { headers: authHeader() }
        );
        setBrands(response.data);
      } catch (error) {
        console.error("Error fetching brands:", error);
      }
    };
    
    fetchBrands();
  }, []);

  return (
    <div>
      <ProductComponents
        header={headers}
        tableTitle={"PRODUCT LIST"}
        apiField={"product"}
        addButton={"+ ADD"}
        createRoute={"/productCreate"}
        updateRoute={"/productEdit"}
        viewRoute={"/productView"}
        selectedBrand={selectedBrand}
        selectedProductType={selectedProductType}
        brands={brands}
        productTypes={productTypes}
        onBrandChange={setSelectedBrand}
        onProductTypeChange={setSelectedProductType}
      />
    </div>
  );
}

export default ProductTable;